import React from "react";

interface PillButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
  variant?: "primary" | "secondary" | "dark" | "basic" | "aiButton" | "danger";
  size?: "sm" | "md" | "lg" | "xl";
  style?: React.CSSProperties;
}

const PillButton: React.FC<PillButtonProps> = ({
  onClick,
  children,
  className = "",
  disabled = false,
  type = "button",
  variant = "dark",
  size = "md",
  style,
}) => {
  const variantStyles: Record<string, string> = {
    primary:
      "bg-violet-600 text-white border-violet-600 hover:bg-violet-700 hover:border-violet-700 dark:bg-violet-600 dark:border-violet-600 dark:hover:bg-violet-700 dark:hover:border-violet-700",
    secondary:
      "bg-gray-800 text-white border-gray-800 hover:bg-gray-700 hover:border-gray-700 dark:bg-gray-700 dark:border-gray-700 dark:hover:bg-gray-600 dark:hover:border-gray-600",
    dark:
      "bg-violet-600 text-white border-violet-600 hover:bg-violet-700 hover:border-violet-700 dark:bg-violet-600 dark:border-violet-600 dark:hover:bg-violet-700 dark:hover:border-violet-700",
    basic:
      "bg-transparent text-gray-800 border-transparent hover:bg-gray-100 dark:text-ez-text-primary dark:hover:bg-gray-800",
    aiButton:
      "bg-transparent text-gray-700 border-gray-400 hover:bg-gray-700 hover:text-white dark:text-gray-200 dark:border-gray-500 dark:hover:bg-gray-600",
    danger:
      "bg-red-600 text-white border-red-600 hover:bg-red-700 hover:border-red-700 dark:bg-red-600 dark:hover:bg-red-700",
  };

  const sizeStyles: Record<string, string> = {
    sm:  "px-3 py-1 text-xs rounded-md",
    md:  "px-4 py-2 text-sm rounded-md min-w-[96px]",
    lg:  "px-5 py-2.5 text-sm rounded-md",
    xl:  "px-6 py-3 text-base rounded-md",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={style}
      className={`inline-flex items-center justify-center gap-2 border font-medium transition-colors duration-150
        ${variantStyles[variant]} ${sizeStyles[size]}
        ${disabled ? "pointer-events-none opacity-50" : ""}
        ${className}`}
    >
      {children}
    </button>
  );
};

export default PillButton;

